import * as Sentry from "@sentry/react";

/**
 * Sentry options for the browser client, built as a value so the integration
 * list is assertable from a test rather than living only inside the
 * `Sentry.init` call at boot.
 *
 * # No Session Replay
 *
 * `replayIntegration()` is deliberately absent, and re-adding it is not a
 * cleanup. Replay runs rrweb, which holds a `MutationObserver` over the whole
 * document plus a node->id mirror of every DOM node it has seen, and buffers
 * the resulting event stream in memory. The opener, unwinding and notifications
 * pages rewrite hundreds of table cells at WebSocket rate and cycle rows
 * through a virtualiser, so that stream never settles.
 *
 * `replaysOnErrorSampleRate` is the sharp edge: it puts a session into buffer
 * mode, where rrweb RECORDS continuously and only the upload is conditional. At
 * 1.0 that is every session, whatever `replaysSessionSampleRate` says.
 *
 * Omitting the integration also drops rrweb from the bundle — nothing imports
 * it, so it tree-shakes. Error reporting is unaffected: `captureException` /
 * `captureMessage` are used across the socket hooks and pages and are untouched.
 */
export function buildSentryOptions(): Sentry.BrowserOptions {
  return {
    environment: import.meta.env.VITE_SENTRY_ENV ?? "",
    dsn: "https://408ef7fc4113eb62879f2a8d5cb6008e@o4511377710776320.ingest.us.sentry.io/4511390012145664",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  };
}
